<template>
<div id="secure">

    <NewTopMenu />
    <div class="container">

        <div class="columns">
            <div class="column is-12">
                <div class="card">
                    <div class="card-header" style="padding: 10px;">
                        <div class="columns">
                            <div class="column">
                                <b-select id="category" name="category" v-model="category" size="is-small" @input="getLeaderboard()">
                                    <option selected value="school">All</option>
                                    <option selected value="kelas">By Class</option>
                                    <option selected value="kumpulan">By Group</option>
                                    <option selected value="teachers">Teacher's/Supervisor's Activities</option>
                                    <option selected value="behavior">By Behavior</option>
                                </b-select>
                            </div>
                            <div class="column">
                                <b-select id="kelasID" name="kelasID" v-model="kelasID" size="is-small" @input="getLeaderboard()" v-show="category=='kelas'">
                                    <option selected value="-1">Select Class</option>
                                    <option v-for="kelas in kelasList" :key="kelas._id" :value="kelas._id">{{ kelas.level }} {{ kelas.name }}</option>
                                </b-select>
                                <b-select id="kumpulanID" name="kumpulanID" v-model="kumpulanID" size="is-small" @input="getLeaderboard()" v-show="category=='kumpulan'">
                                    <option selected value="-1">Select Group</option>
                                    <option v-for="kumpulan in kumpulanList" :key="kumpulan._id" :value="kumpulan._id">{{ kumpulan.name }}</option>
                                </b-select>                                
                                <b-select id="behaviorID" name="behaviorID" v-model="behaviorID" size="is-small" @input="getLeaderboard(1)" v-show="category=='behavior'">
                                    <option selected value="-1">Select Behavior</option>
                                    <option v-for="behavior in behaviorList" :key="behavior._id" :value="behavior._id">{{ behavior.name }}</option>
                                </b-select>
                            </div>
                            <div class="column">
                                <b-select id="durationType" name="durationType" v-model="durationType" size="is-small">
                                    <option value="1" selected>Monthly/Yearly</option>
                                    <option value="2">Month Range</option>
                                    <option value="3">Date Range</option>
                                </b-select>
                            </div>
                            <div class="column" v-show="durationType == 1">
                                <b-select id="duration" name="duration" v-model="duration" size="is-small" @input="getLeaderboard()">
                                    <option :value="currentYear">{{ currentYear }}</option>
                                    <option value="1">January</option>
                                    <option value="2">February</option>
                                    <option value="3">March</option>
                                    <option value="4">April</option>
                                    <option value="5">May</option>
                                    <option value="6">June</option>
                                    <option value="7">July</option>
                                    <option value="8">August</option>
                                    <option value="9">September</option>
                                    <option value="10">October</option>
                                    <option value="11">November</option>
                                    <option value="12">December</option>
                                    <!-- <option value="13">Ramadhan 2020</option> -->
                                    <option value="14" v-show="((schoolID == '5e6598fb9b574f0aededa6db') || (schoolID == '5c1a735fc98da061141475a1'))">Semi Final</option>
                                    <option value="15" v-show="((schoolID == '5e6598fb9b574f0aededa6db') || (schoolID == '5c1a735fc98da061141475a1'))">Final</option>
                                    <option :value="lastYear">{{ lastYear }}</option>
                                </b-select>
                            </div>
                            <div class="column is-3" v-show="durationType == 2">
                                <table><tr><td>
                                <b-select id="durationStartMonth" name="durationStartMonth" v-model="durationStartMonth" size="is-small">
                                    <option value="1">January</option>
                                    <option value="2">February</option>
                                    <option value="3">March</option>
                                    <option value="4">April</option>
                                    <option value="5">May</option>
                                    <option value="6">June</option>
                                    <option value="7">July</option>
                                    <option value="8">August</option>
                                    <option value="9">September</option>
                                    <option value="10">October</option>
                                    <option value="11">November</option>
                                    <option value="12">December</option>
                                </b-select>
                                </td><td style="padding-right: 5px; padding-left: 5px; padding-top: 5px; font-size: 14px;">to</td><td>
                                <b-select id="durationEndMonth" name="durationEndMonth" v-model="durationEndMonth" size="is-small">
                                    <option value="1">January</option>
                                    <option value="2">February</option>
                                    <option value="3">March</option>
                                    <option value="4">April</option>
                                    <option value="5">May</option>
                                    <option value="6">June</option>
                                    <option value="7">July</option>
                                    <option value="8">August</option>
                                    <option value="9">September</option>
                                    <option value="10">October</option>
                                    <option value="11">November</option>
                                    <option value="12">December</option>
                                </b-select>
                                </td></tr></table>
                            </div>
                            <div class="column is-5" v-show="durationType == 3">
                                <table style="margin-top: 3px;"><tr><td>
                                <datepicker v-model="durationStartDaily" wrapper-class="datepicker" placeholder="Starting Date" :value="durationStartDaily" :class="$style.datepicker" :calendar-button="true" calendar-button-icon="fa fa-calendar"></datepicker>
                                </td><td style="padding-right: 5px; padding-left: 5px; padding-top: 5px; font-size: 14px;">to</td><td>
                                <datepicker v-model="durationEndDaily" wrapper-class="datepicker" placeholder="Ending Date" :value="durationEndDaily" :class="$style.datepicker" :calendar-button="true" calendar-button-icon="fa fa-calendar"></datepicker>
                                </td></tr></table>
                            </div>
                            <div class="column" v-show="durationType != 1">
                                <a class="button is-primary is-small" v-on:click="getLeaderboard()" style="height: 25px; margin-top: 3px;">View</a>
                            </div>
                            <div class="column">
                                <b-select id="display" name="display" v-model="display" size="is-small">
                                    <option value="1">Top 10</option>
                                    <option value="2">Top 20</option>
                                    <option value="3">Top 30</option>
                                    <option value="4">Top 40</option>
                                    <option value="5">Top 50</option>
                                    <option value="6">Top 100</option>
                                    <option value="7">Top 300</option>
                                </b-select>
                            </div>
                            <div class="column">
                                <b-select id="sortTopTeachers" name="sortTopTeachers" v-model="sortTopTeachers" size="is-small" style="margin-left: 10px;" @input="sortTeachersAndPoints(topTeachers)" v-show="category=='teachers'">
                                    <option value="0">By Name</option>
                                    <option value="1">By Points</option>
                                    <option value="2">By Scan Count</option>
                                </b-select>
                            </div>
                            <div class="column">
                                <a class="button is-info is-small" v-on:click="getLeaderboard('excel')" v-show="(category!='teachers')">Download As Excel</a>
                            </div>
                        </div>
                    </div>
                    <div class="card-content">
                        <loading :active.sync="isLoading" 
                            :can-cancel="false" 
                            :is-full-page="false">
                        </loading>
                        <div v-show="category!='teachers'">
                            <b-button rounded>Top Leaderboard</b-button>
                            <b-table :data="sortTop(topStudents,display,'student')" :columns="topStudentsColumns" :mobile-cards="false" v-if="category!='teachers'"></b-table>
                        </div>
                        <div v-show="category=='teachers'">
                            <b-button rounded>Top Teachers/Supervisors</b-button>
                            <b-table :data="sortTeachersAndPoints(topTeachers)" :columns="topTeachersColumns" :mobile-cards="false" @click="goTeacherActivitiesView($event)"></b-table>
                        </div>

                        <br/>
                        <div v-show="(category=='school' || category=='behavior')">
                            <b-button rounded>Classes/Departments</b-button>
                            <b-table :data="sortTop(topClasses,display,'class')" :columns="topClassesColumns" :mobile-cards="false" v-if="(category=='school' || category=='behavior')">
                                <loading :active.sync="isLoading1" 
                                    :can-cancel="false" 
                                    :is-full-page="false">
                                </loading>
                            </b-table>
                            
                            <b-button rounded>Groups</b-button>
                            <b-table :data="sortTop(topGroups,display,'group')" :columns="topGroupsColumns" :mobile-cards="false" v-if="(category=='school' || category=='behavior')">
                                <loading :active.sync="isLoading2" 
                                    :can-cancel="false" 
                                    :is-full-page="false">
                                </loading>
                            </b-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import NewTopMenu from "./NewTopMenu";
import axios from "axios";
import { ToastProgrammatic as Toast } from 'buefy'
import Datepicker from 'vuejs-datepicker';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import "./public/style.scss";
const helper = require("../../config/helper")

export default {
    name: "Leaderboard",
    components: {
        NewTopMenu,
        Loading,
        Datepicker
    },
    data() {
        return {
            schoolID: "",
            kelasID: "-1",
            kelasList: [],
            kumpulanID: "-1",
            behaviorID: "-1",
            kumpulanList: [],
            behaviorList: [],
            topStudents: [],
            topClasses: [],
            topGroups: [],
            isLoading: false,
            isLoading1: false,
            isLoading2: false,
            behaviorName: "",
            category: "school",
            duration: 1,
            durationDisplay: "",
            durationType: 1,
            durationStartMonth: 1,
            durationEndMonth: 1,
            durationStartDaily: 1,
            durationEndDaily: 1,
            currentDay: 0,
            currentYear: 0,
            lastYear: 0,
            currentMonth: 0,
            display: 1,
            topTeachers: [],
            sortTopTeachers: 1,
            teacherTotalScanCount: 0,
            teacherTotalPoints: 0,
            selectedTeacher: null,
            props: [],
            topStudentsColumns: [
                {
                        field: 'number',
                        label: '#',
                        width: '20',
                        numeric: true
                },
                {
                    field: 'firstName',
                    label: 'Name',
                },
                {
                    field: "class",
                    label: '',
                },
                {
                    field: 'tempNumber1',
                    label: 'Points',
                    centered: true
                }
            ],
            topClassesColumns: [
                {
                    field: 'number',
                    label: '#',
                    width: '20',
                    numeric: true
                },
                {
                    field: "class",
                    label: 'Class/Department',
                },
                {
                    field: 'tempNumber1',
                    label: 'Points',
                    centered: true
                }
            ],
            topGroupsColumns: [
                {
                    field: 'number',
                    label: '#',
                    width: '20',
                    numeric: true
                },
                {
                    field: "name",
                    label: 'Group',
                },
                {
                    field: 'tempNumber1',
                    label: 'Points',
                    centered: true
                }
            ],
            topTeachersColumns: [
                {
                    field: 'number',
                    label: '#',
                    width: '20',
                    numeric: true
                },
                {
                    field: "name",
                    label: 'Name',
                },
                {
                    field: 'tempNumber1',
                    label: 'Points Awarded',
                    centered: true
                },
                {
                    field: 'tempNumber2',
                    label: 'Scan Count',
                    centered: true
                }
            ],
        };
    },
    beforeMount() {
        this.$emit("authenticated", true);
    },
    created() {
        this.schoolID = localStorage.getItem('schoolID');

        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth()+1; //January is 0!
        this.currentYear = today.getFullYear();
        this.lastYear = this.currentYear - 1
        this.currentMonth = today.getMonth() + 1;  //since month starts from 0
        this.currentDay = today.getDate();
        this.duration = this.currentMonth

        this.durationStartMonth = this.currentMonth
        this.durationEndMonth = this.currentMonth

        this.durationStartDaily = new Date(this.currentYear, this.currentMonth - 1,this.currentDay )
        this.durationEndDaily = new Date(this.currentYear, this.currentMonth - 1,this.currentDay )

        console.log("325 this.durationStartMonth: " + this.durationStartMonth)

        this.getClassList()
        this.getGroupList()        
        this.getBehaviorList()
        this.getLeaderboard()
    },
    mounted(){
    },
    methods: {
        async getLeaderboard(output){
            let self = this
            var durationDisplay = "";
            var setDurationStartDaily = "";
            var setDurationEndDaily = "";

            if (self.durationType == 1){
                if (self.duration >= 2019){
                    durationDisplay = self.duration
                }else if (self.duration == 13){
                    durationDisplay = "Ramadhan 2020"
                }else if (self.duration == 14){
                    durationDisplay = "Semi Final"
                }else if (self.duration == 15){
                    durationDisplay = "Final"
                }else{
                    var displayMonth = helper.displayMonth(self.duration)
                    durationDisplay = displayMonth + " " + self.currentYear
                }
            }else if (self.durationType == 2){
                //monthly range
                var displayStartMonth = helper.displayMonth(self.durationStartMonth)
                var displayEndMonth = helper.displayMonth(self.durationEndMonth)
                durationDisplay = displayStartMonth + " to " + displayEndMonth + " " + self.currentYear
            }else if (self.durationType == 3){
                //daily range
                console.log("this.durationStartDaily: " + this.durationStartDaily)
                console.log("this.durationEndDaily: " + this.durationEndDaily)
                var getDay = this.durationStartDaily.getDate()
                var getMonth = this.durationStartDaily.getMonth() + 1
                if (getDay < 10){
                    getDay = "0" + getDay
                }
                if (getMonth < 10){
                    getMonth = "0" + getMonth
                }
                setDurationStartDaily = this.durationStartDaily.getFullYear() + "" + getMonth + "" + getDay
                
                getDay = this.durationEndDaily.getDate()
                getMonth = this.durationEndDaily.getMonth() + 1
                if (getDay < 10){
                    getDay = "0" + getDay
                }
                if (getMonth < 10){
                    getMonth = "0" + getMonth
                }
                setDurationEndDaily = this.durationEndDaily.getFullYear() + "" + getMonth + "" + getDay

                durationDisplay = setDurationStartDaily + " to " + setDurationEndDaily
            }
            console.log("380 setDurationStartDaily: " + setDurationStartDaily)
            console.log("380 setDurationEndDaily: " + setDurationEndDaily)

            var categoryName = "";

            console.log("385 self.duration: " + self.duration)

            if ((self.category == "school") || (self.category == "behavior")){
                //need to get both top students and top class                
                //get top students first
                if (self.category == "behavior"){
                    if (self.behaviorID == "-1"){
                        self.topStudents = []
                        self.topClasses = []
                        self.topGroups = []
                        return false;
                    }
                }
                
                if (self.duration >= 2020){
                    self.isLoading = true
                    self.isLoading1 = true;
                    self.isLoading2 = true;

                    if (output == "excel"){

                        //first get excel for top students
                        axios.defaults.responseType = 'blob'
                        axios.post(process.env.MY_URL + '/exportToExcelV2/leaderboard/student', {
                            token: localStorage.getItem('jwtTokenV2'),
                            email: localStorage.getItem('email'),
                            data: self.topStudents  //self.topStudents should contain the overall students leaderboard already, since the data should have been fetched when choosing the overall year before clicking the 'Download As Excel' button
                        })
                        .then(response => {
                            const url = window.URL.createObjectURL(new Blob([response.data]));
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', durationDisplay + " Leaderboard for Students.xlsx");
                            document.body.appendChild(link);
                            link.click();         
                            self.isLoading = false
                        })
                        .catch(e => {
                            console.log(e)
                            self.isLoading = false
                            if (e.response.status === 401) {                            
                                Toast.open({
                                    message: "Unauthorized access. Please re-login.",
                                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 5000
                                })
                            } else {
                                Toast.open({
                                    message: 'Error: ' + e.response.data.msg,
                                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 5000
                                })
                            }
                        })

                        //now get excel for top classes
                        axios.defaults.responseType = 'blob'
                        axios.post(process.env.MY_URL + '/exportToExcelV2/leaderboard/class', {
                            token: localStorage.getItem('jwtTokenV2'),
                            email: localStorage.getItem('email'),
                            data: self.topClasses  //self.topClasses should contain the overall classes leaderboard already, since the data should have been fetched when choosing the overall year before clicking the 'Download As Excel' button
                        })
                        .then(response => {
                            const url = window.URL.createObjectURL(new Blob([response.data]));
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', durationDisplay + " Leaderboard for Classes.xlsx");
                            document.body.appendChild(link);
                            link.click();         
                            self.isLoading1 = false
                        })
                        .catch(e => {
                            console.log(e)
                            self.isLoading1 = false
                            if (e.response.status === 401) {                            
                                Toast.open({
                                    message: "Unauthorized access. Please re-login.",
                                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 5000
                                })
                            } else {
                                Toast.open({
                                    message: 'Error: ' + e.response.data.msg,
                                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 5000
                                })
                            }
                        })

                        //now get excel for top groups
                        axios.defaults.responseType = 'blob'
                        axios.post(process.env.MY_URL + '/exportToExcelV2/leaderboard/group', {
                            token: localStorage.getItem('jwtTokenV2'),
                            email: localStorage.getItem('email'),
                            data: self.topGroups  //self.topGroups should contain the overall groups leaderboard already, since the data should have been fetched when choosing the overall year before clicking the 'Download As Excel' button
                        })
                        .then(response => {
                            const url = window.URL.createObjectURL(new Blob([response.data]));
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', durationDisplay + " Leaderboard for Groups.xlsx");
                            document.body.appendChild(link);
                            link.click();         
                            self.isLoading2 = false
                        })
                        .catch(e => {
                            console.log(e)
                            self.isLoading2 = false
                            if (e.response.status === 401) {                            
                                Toast.open({
                                    message: "Unauthorized access. Please re-login.",
                                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 5000
                                })
                            } else {
                                Toast.open({
                                    message: 'Error: ' + e.response.data.msg,
                                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 5000
                                })
                            }
                        })
                        
                    }else{
                        output = "";
                        self.topStudents = []
                        self.topClasses = []
                        self.topGroups = []

                        axios.defaults.responseType = 'json'
                        console.log("for the whole year's student leaderboard, we're going to use promise instead of getting it all from the server which may cause load problem")
                        var durationEndMonth = self.currentMonth;
                        if (self.duration != self.currentYear){
                            durationEndMonth = 12   //take for the whole jan - dec
                        }
                        var promisesStudentLeaderboard = []
                        for (var i = 1; i <= durationEndMonth; i++){
                            promisesStudentLeaderboard.push(await this.callURL(self.category,"student","","",self.behaviorID,self.duration,i, "","","","","",output,""))
                        }
                        var yearlyStudentLeaderboard = await Promise.all(promisesStudentLeaderboard)
                        var topStudent;
                        for (var j = 0; j < yearlyStudentLeaderboard[0].data.length; j++){ //we can do this since student ordering should be the same throughout the loop
                            var totalPoints = 0

                            for (var k = 0; k < yearlyStudentLeaderboard.length; k++){
                                for (var m = 0; m < yearlyStudentLeaderboard[k].data.length; m++){
                                    if (yearlyStudentLeaderboard[0].data[j]._id == yearlyStudentLeaderboard[k].data[m]._id){
                                        totalPoints = totalPoints + yearlyStudentLeaderboard[k].data[m].tempNumber1
                                    }
                                }
                            }

                            topStudent = {
                                firstName :yearlyStudentLeaderboard[0].data[j].firstName,
                                lastName :yearlyStudentLeaderboard[0].data[j].lastName,
                                tempNumber1 :totalPoints,
                                kelasID: {
                                    level: yearlyStudentLeaderboard[0].data[j].kelasID.level,
                                    name: yearlyStudentLeaderboard[0].data[j].kelasID.name,
                                }
                            }
                            self.topStudents.push(topStudent)
                        }
                        self.isLoading = false;
                        
                        axios.defaults.responseType = 'json'
                        console.log("for the whole year's class leaderboard, we're going to use promise instead of getting it all from the server which may cause load problem")
                        var promisesClassLeaderboard = []
                        var durationEndMonth = self.currentMonth;
                        if (self.duration != self.currentYear){
                            durationEndMonth = 12   //take for the whole jan - dec
                        }
                        for (var i = 1; i <= durationEndMonth; i++){
                            promisesClassLeaderboard.push(await this.callURL(self.category,"kelas","","",self.behaviorID,self.duration,i,"","","","","",output,""))
                        }
                        var yearlyClassLeaderboard = await Promise.all(promisesClassLeaderboard)
                        var topClass;
                        for (var j = 0; j < yearlyClassLeaderboard[0].data.length; j++){ //we can do this since student ordering should be the same throughout the loop
                            var totalPoints = 0

                            for (var k = 0; k < yearlyClassLeaderboard.length; k++){
                                for (var m = 0; m < yearlyClassLeaderboard[k].data.length; m++){
                                    if (yearlyClassLeaderboard[0].data[j]._id == yearlyClassLeaderboard[k].data[m]._id){
                                        totalPoints = totalPoints + yearlyClassLeaderboard[k].data[m].tempNumber1
                                    }
                                }
                            }

                            topClass = {
                                level :yearlyClassLeaderboard[0].data[j].level,
                                name :yearlyClassLeaderboard[0].data[j].name,
                                tempNumber1 :totalPoints,
                            }
                            self.topClasses.push(topClass)
                        }
                        self.isLoading1 = false;
                        
                        axios.defaults.responseType = 'json'
                        console.log("for the whole year's group leaderboard, we're going to use promise instead of getting it all from the server which may cause load problem")
                        var promisesGroupLeaderboard = []
                        var durationEndMonth = self.currentMonth;
                        if (self.duration != self.currentYear){
                            durationEndMonth = 12   //take for the whole jan - dec
                        }
                        for (var i = 1; i <= durationEndMonth; i++){
                            promisesGroupLeaderboard.push(await this.callURL(self.category,"group","","",self.behaviorID,self.duration,i,"","","","","",output,""))
                        }
                        var yearlyGroupLeaderboard = await Promise.all(promisesGroupLeaderboard)
                        var topGroup;
                        for (var j = 0; j < yearlyGroupLeaderboard[0].data.length; j++){ //we can do this since student ordering should be the same throughout the loop
                            var totalPoints = 0

                            for (var k = 0; k < yearlyGroupLeaderboard.length; k++){
                                for (var m = 0; m < yearlyGroupLeaderboard[k].data.length; m++){
                                    if (yearlyGroupLeaderboard[0].data[j]._id == yearlyGroupLeaderboard[k].data[m]._id){
                                        totalPoints = totalPoints + yearlyGroupLeaderboard[k].data[m].tempNumber1
                                    }
                                }
                            }

                            topGroup = {
                                name :yearlyGroupLeaderboard[0].data[j].name,
                                tempNumber1 :totalPoints,
                            }
                            self.topGroups.push(topGroup)
                        }
                        self.isLoading2 = false;
                    }

                }else{
                    console.log("613 imin sini ke: " + self.durationStartMonth)
                    console.log("613 imin sini ke: " + self.durationEndMonth)
                    self.isLoading = true
                    if (output == "excel"){
                        axios.defaults.responseType = 'blob'
                        axios.post(process.env.MY_URL + '/exportToExcelV2/leaderboard/student', {
                            token: localStorage.getItem('jwtTokenV2'),
                            email: localStorage.getItem('email'),
                            data: self.topStudents  //self.topStudents should contain the overall students leaderboard already, since the data should have been fetched when choosing the overall year before clicking the 'Download As Excel' button
                        })
                        .then(response => {
                            const url = window.URL.createObjectURL(new Blob([response.data]));
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', durationDisplay + " Leaderboard for Students.xlsx");
                            document.body.appendChild(link);
                            link.click();
                            self.isLoading = false
                        })
                        .catch(e => {
                            console.log(e)
                            self.isLoading = false
                            if (e.response.status === 401) {                            
                                Toast.open({
                                    message: "Unauthorized access. Please re-login.",
                                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 5000
                                })
                            } else {
                                Toast.open({
                                    message: 'Error: ' + e.response.data.msg,
                                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 5000
                                })
                            }
                        })
                    }else{
                        output = "";
                        self.topStudents = []
                        axios.defaults.responseType = 'json'
                        axios.post(process.env.MY_URL + '/leaderboardV2_old/list', {
                            token: localStorage.getItem('jwtTokenV2'),
                            email: localStorage.getItem('email'),
                            category: self.category,
                            behaviorID: self.behaviorID,
                            subCategory: "student",
                            year: self.currentYear,
                            duration: self.duration,
                            durationType: self.durationType,
                            durationStartMonth: self.durationStartMonth,
                            durationEndMonth: self.durationEndMonth,
                            durationStartDaily: setDurationStartDaily,
                            durationEndDaily: setDurationEndDaily,
                            output: output
                        })
                        .then(response => {
                            self.topStudents = response.data   
                            self.isLoading = false
                        })
                        .catch(e => {
                            console.log(e)
                            self.isLoading = false
                            if (e.response.status === 401) {                            
                                Toast.open({
                                    message: "Unauthorized access. Please re-login.",
                                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 5000
                                })
                            } else {
                                Toast.open({
                                    message: 'Error: ' + e.response.data.msg,
                                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 5000
                                })
                            }
                        })
                    }
                    
                    //bawah ni top class
                    self.isLoading1 = true
                    if (output == "excel"){
                        axios.defaults.responseType = 'blob'
                        axios.post(process.env.MY_URL + '/exportToExcelV2/leaderboard/class', {
                            token: localStorage.getItem('jwtTokenV2'),
                            email: localStorage.getItem('email'),
                            data: self.topClasses  //self.topClasses should contain the overall students leaderboard already, since the data should have been fetched when choosing the overall year before clicking the 'Download As Excel' button
                        })
                        .then(response => {
                            const url = window.URL.createObjectURL(new Blob([response.data]));
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', durationDisplay + " Leaderboard for Classes.xlsx");
                            document.body.appendChild(link);
                            link.click();
                            self.isLoading1 = false
                        })
                        .catch(e => {
                            console.log(e)
                            self.isLoading1 = false
                            if (e.response.status === 401) {                            
                                Toast.open({
                                    message: "Unauthorized access. Please re-login.",
                                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 5000
                                })
                            } else {
                                Toast.open({
                                    message: 'Error: ' + e.response.data.msg,
                                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 5000
                                })
                            }
                        })
                    }else{
                        output = "";
                        self.topClasses = []
                        axios.defaults.responseType = 'json'
                        axios.post(process.env.MY_URL + '/leaderboardV2_old/list', {
                            token: localStorage.getItem('jwtTokenV2'),
                            email: localStorage.getItem('email'),
                            category: self.category,
                            behaviorID: self.behaviorID,
                            subCategory: "kelas",
                            year: self.currentYear,
                            duration: self.duration,
                            durationType: self.durationType,
                            durationStartMonth: self.durationStartMonth,
                            durationEndMonth: self.durationEndMonth,
                            durationStartDaily: setDurationStartDaily,
                            durationEndDaily: setDurationEndDaily,
                            output: output
                        })
                        .then(response => {
                            self.topClasses = response.data
                            self.isLoading1 = false
                        })
                        .catch(e => {
                            console.log(e)
                            self.isLoading1 = false
                            if (e.response.status === 401) {                            
                                Toast.open({
                                    message: "Unauthorized access. Please re-login.",
                                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 5000
                                })
                            } else {
                                Toast.open({
                                    message: 'Error: ' + e.response.data.msg,
                                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 5000
                                })
                            }
                        })
                    }
                    
                    //bawah ni top group
                    self.isLoading2 = true
                    if (output == "excel"){
                        axios.defaults.responseType = 'blob'
                        axios.post(process.env.MY_URL + '/exportToExcelV2/leaderboard/group', {
                            token: localStorage.getItem('jwtTokenV2'),
                            email: localStorage.getItem('email'),
                            data: self.topGroups  //self.topGroups should contain the overall students leaderboard already, since the data should have been fetched when choosing the overall year before clicking the 'Download As Excel' button
                        })
                        .then(response => {
                            const url = window.URL.createObjectURL(new Blob([response.data]));
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', durationDisplay + " Leaderboard for Groups.xlsx");
                            document.body.appendChild(link);
                            link.click();
                            self.isLoading2 = false
                        })
                        .catch(e => {
                            console.log(e)
                            if (e.response.status === 401) {                            
                                Toast.open({
                                    message: "Unauthorized access. Please re-login.",
                                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 5000
                                })
                            } else {
                                Toast.open({
                                    message: 'Error: ' + e.response.data.msg,
                                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 5000
                                })
                            }
                            self.isLoading2 = false
                        })

                    }else{
                        output = "";
                        self.topGroups = []
                        axios.defaults.responseType = 'json'
                        axios.post(process.env.MY_URL + '/leaderboardV2_old/list', {
                            token: localStorage.getItem('jwtTokenV2'),
                            email: localStorage.getItem('email'),
                            category: self.category,
                            behaviorID: self.behaviorID,
                            subCategory: "group",
                            year: self.currentYear,
                            duration: self.duration,
                            durationType: self.durationType,
                            durationStartMonth: self.durationStartMonth,
                            durationEndMonth: self.durationEndMonth,
                            durationStartDaily: setDurationStartDaily,
                            durationEndDaily: setDurationEndDaily,
                            output: output
                        })
                        .then(response => {
                            self.topGroups = response.data
                            self.isLoading2 = false
                        })
                        .catch(e => {
                            console.log(e)
                            if (e.response.status === 401) {                            
                                Toast.open({
                                    message: "Unauthorized access. Please re-login.",
                                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 5000
                                })
                            } else {
                                Toast.open({
                                    message: 'Error: ' + e.response.data.msg,
                                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 5000
                                })
                            }
                            self.isLoading2 = false
                        })
                    }
                }

            }else{

                if (self.category == "kelas"){
                    if (self.kelasID == "-1"){
                        if (output == "excel"){
                            Toast.open({
                                message: "Please select the class first",
                                type: 'is-warning', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 5000
                            })
                        }
                        return false;
                    }
                    var findKelasID = self.kelasID
                    let selectedCategory = _.find(self.kelasList, {'_id': findKelasID});
                    categoryName = selectedCategory.level + " " + selectedCategory.name
                    self.topStudents = []

                }else if (self.category == "kumpulan"){
                    if (self.kumpulanID == "-1"){
                        if (output == "excel"){
                            Toast.open({
                                message: "Please select the group first",
                                type: 'is-warning', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 5000
                            })
                        }
                        return false;
                    }
                    var findKumpulanID = self.kumpulanID
                    let selectedCategory = _.find(self.kumpulanList, {'_id': findKumpulanID});
                    categoryName = selectedCategory.name
                    self.topStudents = []

                }else if (self.category == "teachers"){
                    categoryName = "Teacher's Activities"
                    self.topTeachers = []
                }

                if (output == "excel"){
                    axios.defaults.responseType = 'blob'
                }else{
                    output = "";
                    axios.defaults.responseType = 'json'
                }
                self.isLoading = true

                if ((self.durationType == 1) && (self.duration >= 2020)){
                    console.log("711 for the whole year, fetch the data month by month")
                    
                    var durationEndMonth = self.currentMonth;
                    if (self.duration != self.currentYear){
                        durationEndMonth = 12   //take for the whole jan - dec
                    }

                    var promisesLeaderboard = []
                    for (var i = 1; i <= durationEndMonth; i++){
                        promisesLeaderboard.push(await this.callURL(self.category,"",self.kelasID,self.kumpulanID,"",self.duration,i,self.durationType,"","","","",self.output,self.categoryName))
                    }
                    var yearlyPromisesLeaderboard = await Promise.all(promisesLeaderboard)

                    var topData;
                    if (self.category == "teachers"){
                        for (var j = 0; j < yearlyPromisesLeaderboard[0].data.teacherList.length; j++){ //we can do this since data ordering should be the same throughout the loop
                            var totalPoints = 0
                            var totalScanCount = 0

                            for (var k = 0; k < yearlyPromisesLeaderboard.length; k++){
                                for (var m = 0; m < yearlyPromisesLeaderboard[k].data.teacherList.length; m++){
                                    if (yearlyPromisesLeaderboard[0].data.teacherList[j]._id == yearlyPromisesLeaderboard[k].data.teacherList[m]._id){
                                        totalPoints = totalPoints + yearlyPromisesLeaderboard[k].data.teacherList[m].tempNumber1
                                        totalScanCount = totalScanCount + yearlyPromisesLeaderboard[k].data.teacherList[m].tempNumber2
                                    }
                                }
                            }
                            topData = {
                                firstName :yearlyPromisesLeaderboard[0].data.teacherList[j].firstName,
                                lastName :yearlyPromisesLeaderboard[0].data.teacherList[j].lastName,
                                tempNumber1 :totalPoints,
                                tempNumber2 : totalScanCount
                            }
                            self.topTeachers.push(topData)                           
                        }

                    }else{
                        for (var j = 0; j < yearlyPromisesLeaderboard[0].data.length; j++){ //we can do this since data ordering should be the same throughout the loop
                            var totalPoints = 0

                            for (var k = 0; k < yearlyPromisesLeaderboard.length; k++){
                                for (var m = 0; m < yearlyPromisesLeaderboard[k].data.length; m++){
                                    if (yearlyPromisesLeaderboard[0].data[j]._id == yearlyPromisesLeaderboard[k].data[m]._id){
                                        totalPoints = totalPoints + yearlyPromisesLeaderboard[k].data[m].tempNumber1
                                    }
                                }
                            }
                                
                            topData = {
                                firstName :yearlyPromisesLeaderboard[0].data[j].firstName,
                                lastName :yearlyPromisesLeaderboard[0].data[j].lastName,
                                tempNumber1 :totalPoints,
                                kelasID: {
                                    level: yearlyPromisesLeaderboard[0].data[j].kelasID.level,
                                    name: yearlyPromisesLeaderboard[0].data[j].kelasID.name,
                                }
                            }
                            self.topStudents.push(topData)                            
                        }
                    }                    
                    self.isLoading = false;

                }else{
                    axios.post(process.env.MY_URL + '/leaderboardV2_old/list', {
                        token: localStorage.getItem('jwtTokenV2'),
                        email: localStorage.getItem('email'),
                        category: self.category,
                        kelasID: self.kelasID,
                        kumpulanID: self.kumpulanID,
                        year: self.currentYear,
                        duration: self.duration,
                        durationType: self.durationType,
                        durationStartMonth: self.durationStartMonth,
                        durationEndMonth: self.durationEndMonth,
                        durationStartDaily: setDurationStartDaily,
                        durationEndDaily: setDurationEndDaily,
                        output: output,
                        categoryName: categoryName
                    })
                    .then(response => {
                        if (output == "excel"){
                            const url = window.URL.createObjectURL(new Blob([response.data]));
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', durationDisplay + " Leaderboard for " + categoryName + ".xlsx");
                            document.body.appendChild(link);
                            link.click();
                        }else{
                            if (self.category == "teachers"){
                                self.topTeachers = response.data.teacherList
                                self.teacherTotalScanCount = response.data.totalCount
                                self.teacherTotalPoints = 0
                                for (var i = 0; i < self.topTeachers.length; i++){
                                    self.teacherTotalPoints = self.teacherTotalPoints + self.topTeachers[i].tempNumber1
                                }
                            }else{
                                self.topStudents = response.data
                            }
                        }
                        self.isLoading = false
                    })
                    .catch(e => {
                        console.log(e)
                        self.isLoading = false
                        if (e.response.status === 401) {                            
                            Toast.open({
                                message: "Unauthorized access. Please re-login.",
                                type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 5000
                            })
                        } else {
                            Toast.open({
                                message: 'Error: ' + e.response.data.msg,
                                type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 5000
                            })
                        }
                    })
                }
            }

        },
        async callURL(category,subCategory,kelasID,kumpulanID,behaviorID,year,duration,durationType,durationStartMonth,durationEndMonth,durationStartDaily,durationEndDaily,output,categoryName){
            console.log("entering callURL with category: " + category + ", subCategory: " + subCategory + ", kelasID: " + kelasID + ", kumpulanID: " + kumpulanID + ", behaviorID: " + behaviorID + ", year: " + year + ", duration: " + duration + ", durationType: " + durationType + ", durationStartMonth: " + durationStartMonth + ", durationEndMonth: " + durationEndMonth + ", durationStartDaily: " + durationStartDaily + ", durationEndDaily: " + durationEndDaily + ", output: " + output + ", categoryName: " + categoryName)
            var getResult = await axios.post(process.env.MY_URL + '/leaderboardV2_old/list', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email'),
                category: category,
                subCategory: subCategory,
                kelasID: kelasID,
                kumpulanID: kumpulanID,
                behaviorID: behaviorID,
                year: year,
                duration: duration,
                durationType: durationType,
                durationStartMonth: durationStartMonth,
                durationEndMonth: durationEndMonth,
                durationStartDaily: durationStartDaily,
                durationEndDaily: durationEndDaily,
                output: output,
                categoryName: categoryName
            })
            return getResult
        },
        displayDate(date){
            try{
                var getYear = date.substring(0,4);
                var getMonth = date.substring(4,6);
                var getDay = date.substring(6);

                return getDay + "/" + getMonth + "/" + getYear;
            }catch(err){
                console.log(err)
                return date;
            }
        },
        displayInfo(dataType,remarks,status){
            if (dataType == 2){
                if (status == 2){
                    return "Late"
                }else{
                    return "On-Time"
                }
            }else{
                return remarks
            }
        },
        getClassList(){
            let self = this

            axios.defaults.responseType = 'json'
            axios.post(process.env.NEW_ENDPOINT + '/classes/list/', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email'),
            })
            .then(response => {
                self.kelasList = response.data.kelasList                
            })
            .catch(e => {
                console.log(e)
            })
        },
        getGroupList(){
            let self = this

            axios.defaults.responseType = 'json'
            axios.post(process.env.NEW_ENDPOINT + '/kumpulan/list/', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email'),
            })
            .then(response => {
                self.kumpulanList = response.data.kumpulanList
            })
            .catch(e => {
                console.log(e)
            })
        },
        getBehaviorList(){
            let self = this

            axios.defaults.responseType = 'json'
            axios.post(process.env.NEW_ENDPOINT + '/behaviors/list/', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email'),
            })
            .then(response => {
                self.behaviorList = response.data
            })
            .catch(e => {
                console.log(e)
            })
        },
        sortTop(arrays,display,what){
            var show = 100
            display = parseInt(display)
            switch(display) {
                case 1:
                    show = 10
                    break;
                case 2:
                    show = 20
                    break;
                case 3:
                    show = 30
                    break;
                case 4:
                    show = 40
                    break;
                case 5:
                    show = 50
                    break;
                case 6:
                    show = 100
                    break;
                case 7:
                    show = 300
                    break;
                default:
                    show = 100
                    // code block
            }
            var output = _.orderBy(arrays, 'tempNumber1', 'desc').splice(0,show); //we're using the magical lodash function here to sort by points and return the top needed
            for (var i = 0; i < output.length; i++){
                output[i].number = i + 1
                if (what=="student"){
                    if (this.category == "kelas"){
                        output[i].class = this.getKelasName(this.kelasID)
                    }else{
                        if (output[i].kelasID){
                            output[i].class = output[i].kelasID.level + " " + output[i].kelasID.name
                        }
                    }
                }else if (what=="class"){
                    output[i].class = output[i].level + " " + output[i].name
                }
                output[i].tempNumber1 = this.roundTo2DecimalPlaces(output[i].tempNumber1)
            }
            return output
        },
        sortTeachersAndPoints(arrays){
            var output;
            if (this.sortTopTeachers == 1){  //points
                output = _.orderBy(arrays, 'tempNumber1', 'desc');  //we're using the magical lodash function here
            }else if (this.sortTopTeachers == 2){  //scan count
                output = _.orderBy(arrays, 'tempNumber2', 'desc');  //we're using the magical lodash function here
            }else{  //name
                output = _.orderBy(arrays, 'firstName', 'asc');  //we're using the magical lodash function here
            }
            for (var i = 0; i < output.length; i++){
                output[i].number = i + 1
                output[i].name = output[i].firstName + " " + output[i].lastName
                output[i].tempNumber1 = this.roundTo2DecimalPlaces(output[i].tempNumber1)
            }
            return output
        },
        getKelasName(kelasID){
            var findKelas = _.find(this.kelasList, {'_id': kelasID})    //use lodash to find particular object inside array
            var kelasLevelName = "";
            if (findKelas){
                kelasLevelName = findKelas.level + " " + findKelas.name
            }
            return kelasLevelName;
        },
        roundTo2DecimalPlaces(points){  //use lodash to round the points to 2 decimal places
            return _.round(points, 2)
            // return _.round(points, 2).toFixed(2)
        },
        goTeacherActivitiesView(data){
            console.log("goTeacherActivitiesView with this.duration: " + this.duration)
            console.log(data._id)
            console.log(data.name)
            this.$store.commit('UPDATE_TEACHER_ID',data._id)
            this.$store.commit('UPDATE_TEACHER_NAME',data.name)
            this.$store.commit('UPDATE_DURATION',this.duration)
            localStorage.setItem('TEACHER_ID',data._id)
            localStorage.setItem('TEACHER_NAME',data.name)
            localStorage.setItem('DURATION',this.duration)
            this.$router.push({
                name: "TeacherActivitiesView"
            });
        },
    },
};
</script>

<style scoped>
.bottom-border{
    border-bottom: 1px solid #CCC
}
.container{
    padding: 10px;
}
.text-center{
    text-align: center;
}
</style>
<style module>
.datepicker input{
    border: none; /* <-- This thing here */
    border:1px solid #1849c8;
    border-radius: 5px;
    text-align: center;
    font-size: 14px;
}
</style>


// WEBPACK FOOTER //
// src/components/Leaderboard_old.vue